import { Injectable } from '@angular/core';
import { LoginService } from './login/login.service';

@Injectable({
  providedIn: 'root'
})

export class AppMenuService {

	private Jsn:any 

	constructor(private loginService: LoginService){
		
	}

	getAppMenus() {
		const profile:string=this.loginService.getVariableSesion("profile");
		return this.getMenu(profile);
	}

	getMenu(profile:string)
	{
		// profile = 'Compras'
		switch (profile) {

			case "Administrador":{
				this.Jsn = [
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'url': '/proveedores'
					},
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores Alta Banco',
						'url': '/proveedores/proveedores-lista-banco'
					},
					{
						'icon': 'fa-solid fa-list-check',
						'title': 'Aprobación de Proveedores',
						'url': '/aprobaciones'
					},
					/*{
						'icon': 'fa-solid fa-cart-shopping',
						'title': 'Compras',
						'url': '/compras',
						'submenu': [	
							{
								'title': 'Solicitudes',
								'url': 'compras/solicitudes'
							},
							{
								'title': 'Pre-Ordenes Compra',
								'url': 'compras/solicitudes-pre-compra'
							},
							{
								'title': 'Ordenes Compra',
								'url': 'compras/lista-oc'
							},
						   /* {
								'title': 'Solicitudes por Aprobar Contraloría', //contraloria
								'url': 'compras/solicitudes-por-aprobar-contraloria'
							},
							{
								'title': 'Solicitudes por Aprobar Operativo', //operativp
								'url': 'compras/solicitudes-por-aprobar'
							},*/
							// {
							// 	'title': 'Aprobaciones',
							// 	'url': 'compras/aprobaciones'
							// },
						//]
					//},
					{
						'icon': 'fa-solid fa-address-book',
						'title': 'Lista Sat',
						'url': '/lista-sat'
					},
					{
						'icon': 'fa-solid fa-credit-card',
						'title': 'Reportes',
						'url': '/cuentas-externas',
						'submenu': [	
							{
								'title': 'Cuentas Externas Nacionales',
								'url': 'reporte/cuentas-externas'
							},
							{
								'title': 'Cuentas Internas Nacionales',
								'url': 'reporte/cuentas-internas'
							},
						]
					},
					/*{
						'icon': 'fa-solid fa-book',
						'title': 'Configuraciones',
						'url': '/configuracion',
						'submenu': [
							{
								'title': 'Conceptos',
								'url': 'configuracion/conceptos'
							},
							{
								'title': 'Tasas de Proveedores',
								'url': 'configuracion/tasas'
							},
							{
								'title': 'Usuarios',
								'url': 'configuracion/asignacionUsuarios'
							},
							{
								'title': 'Restricciones',
								'url': 'configuracion/restricciones'
							},
							{
								'title': 'Productos SAT',
								'url': 'configuracion/productosSat'
							}

						]
					}*/,
				]
				break;
			}

			case "Validador":{
				this.Jsn = [
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'submenu': [
							{
								'title': 'Proveedores',
								'url': '/proveedores'
							},
							{
								'title': 'Proveedores por validar',
								'url': '/proveedores/validar'
							}
						]
						
					}
				]
				break;
			}

			case "Solicitante":{
				this.Jsn = [
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'url': '/proveedores',
					},
					/*{
						'icon': 'fa-solid fa-cart-shopping',
						'title': 'Compras',
						'url': '/compras',
						'submenu': [
							{
								'title': 'Solicitudes de Compra',
								'url': 'compras/solicitudes'
							},
							{
								'title': 'Pre-Ordenes Compra',
								'url': 'compras/solicitudes-pre-compra'
							},
							{
								'title': 'Ordenes Compra',
								'url': 'compras/lista-oc'
							},
						]
					},*/
				]
				break;
			}

			case "Pagos": {
				this.Jsn = [
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores Alta Banco',
						'url': '/proveedores/proveedores-lista-banco'
					},
					{
						'icon': 'fa-solid fa-credit-card',
						'title': 'Reportes',
						'url': '/cuentas-externas',
						'submenu': [	
							{
								'title': 'Cuentas Externas Nacionales',
								'url': 'reporte/cuentas-externas'
							},
							{
								'title': 'Cuentas Internas Nacionales',
								'url': 'reporte/cuentas-internas'
							},
						]
					}
				]
				break;
			}

			case "Contraloría":{
				this.Jsn = [
					{
						'icon': 'fa-solid fa-list-check',
						'title': 'Aprobaciones',
						'url': '/aprobaciones'
					},
					/*{
						'icon': 'fa-solid fa-cart-shopping',
						'title': 'Solcitudes de Compras',
						'url': '/compras',
						'submenu': [
							{
								'title': 'Solicitudes por Aprobar',
								'url': 'compras/solicitudes-por-aprobar-contraloria'
							},
							{
								'title': 'Órdenes de Compra por Aprobar',
								'url': 'compras/lista-oc'
							}
						]
					}*/,
					/*{
						'icon': 'fa-solid fa-book',
						'title': 'Configuraciones',
						'url': '/configuracion',
						'submenu': [
							{
								'title': 'Conceptos',
								'url': 'configuracion/conceptos'
							},
							{
								'title': 'Tasas de Proveedores',
								'url': 'configuracion/tasas'
							},
							{
								'title': 'Usuarios',
								'url': 'configuracion/asignacionUsuarios'
							},
							{
								'title': 'Restricciones',
								'url': 'configuracion/restricciones'
							},
							{
								'title': 'Productos SAT',
								'url': 'configuracion/productosSat'
							}

						]
					}*/,
				]
				break;
			}

			case "Autorizador":{
				this.Jsn = [
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'url': '/proveedores'
					},
					{
						'icon': 'fa-solid fa-list-check',
						'title': 'Aprobación de Proveedores',
						'url': '/aprobaciones'
					},
					{
						'icon': 'fa-solid fa-address-book',
						'title': 'Lista Sat',
						'url': '/lista-sat'
					},
					/*{
						'icon': 'fa-solid fa-cart-shopping',
						'title': 'Compras',
						'url': '/compras',
						'submenu': [
							{
								'title': 'Solicitudes de Compra',
								'url': 'compras/solicitudes-por-aprobar'
							},
							{
								'title': 'Pre-Ordenes Compra',
								'url': 'compras/solicitudes-pre-compra'
							},
							{
								'title': 'Ordenes Compra',
								'url': 'compras/lista-oc'
							},
						]
					},*/
				]
				break;
			}

			case "Autorizador Funcional":{
				this.Jsn = [
					/*{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'url': '/proveedores'
					},
					{
						'icon': 'fa-solid fa-list-check',
						'title': 'Aprobaciones',
						'url': '/aprobaciones'
					},
					{
						'icon': 'fa-solid fa-address-book',
						'title': 'Lista Sat',
						'url': '/lista-sat'
					},*/
					//{
						//'icon': 'fa-solid fa-cart-shopping',
						//'title': 'Compras',
						//'url': '/compras',
						//'submenu': [
							/*{
								'title': 'Solicitudes de Compra',
								'url': 'compras/solicitudes-por-aprobar'
							},*/
							/*{
								'title': 'Pre-Ordenes Compra',
								'url': 'compras/solicitudes-pre-compra'
							},*/
							/*{
								'title': 'Ordenes Compra',
								'url': 'compras/lista-oc'
							},*/
						//]
					//},
					/*{
						'icon': 'fa-solid fa-address-book',
						'title': 'Anticipos',
						'url': '/anticipos'
					}*/
				]
				break;
			}

			case "Autorizador Operativo":{
				this.Jsn = [
					/*{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'url': '/proveedores'
					},
					{
						'icon': 'fa-solid fa-list-check',
						'title': 'Aprobaciones',
						'url': '/aprobaciones'
					},
					{
						'icon': 'fa-solid fa-address-book',
						'title': 'Lista Sat',
						'url': '/lista-sat'
					},*/
					/*{
						'icon': 'fa-solid fa-cart-shopping',
						'title': 'Compras',
						'url': '/compras',
						'submenu': [
							{
								'title': 'Solicitudes de Compra',
								'url': 'compras/solicitudes-por-aprobar'
							},
							{
								'title': 'Pre-Ordenes Compra',
								'url': 'compras/solicitudes-pre-compra'
							},
							{
								'title': 'Ordenes Compra',
								'url': 'compras/lista-oc'
							},
						]
					}*/,
				]
				break;
			}

			default: 
				
		}

		return this.Jsn;
		
	}
}